import React from "react";

function Button(props) {
  const {
    className,
    text,
    handleClick,
    symbol,
    isDisabled,
    imgPath,
    type,
    imgClass,
    name,
  } = props;
  return (
    <button
      name={name}
      className={className}
      onClick={handleClick}
      type={type}
      disabled={isDisabled}
    >
      {imgPath && <img className={imgClass} src={imgPath} alt="img" />}
      {text}
      {symbol && <span id="super">{symbol}</span>}
    </button>
  );
}

export default Button;
